var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiteJabber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 168 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#siteJabber_svg__a)",
    d: "M9.8 37.3a1.2 1.2 0 01-1-.4c-.2-.2-.3-.5-.3-1 0-.3 0-.6.3-.9l4.8-5.2c.3-.2.6-.4 1-.4.3 0 .6.2.8.4.3.2.4.6.4 1s0 .6-.3.9l-4.8 5.2c-.3.2-.6.4-1 .4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#siteJabber_svg__b)",
    d: "M1.8 29.5c-.3 0-.6-.2-.9-.4a1.3 1.3 0 01-.4-1c0-.3.2-.6.4-.9l4.5-4.7c.2-.2.6-.4 1-.4.3 0 .6.2.8.4.3.3.4.6.4 1 0 .3-.1.7-.4 1L2.7 29a1.3 1.3 0 01-.9.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#siteJabber_svg__c)",
    d: "M2.3 37.2A1.3 1.3 0 011 35.9c0-.4.1-.7.4-1l9-9.5c.3-.2.6-.4 1-.4.3 0 .6.2.8.4.6.5.6 1.4 0 2l-9 9.4c-.2.3-.6.4-1 .4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#siteJabber_svg__d)",
    d: "M7.8 17.8a43 43 0 0121.8-11 .4.4 0 01.4.4 41 41 0 01-10.8 21.5.8.8 0 01-1.3-.2l-2-4.6-2.4.6a.7.7 0 01-.7-.8l.6-2.4-5.4-2c-.6-.3-.7-1-.2-1.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#siteJabber_svg__e)",
    d: "M35 26.6l-9.8.1a1 1 0 00-.8.5c-1 1.7-4.3 7-6.8 9.3-.6.6-1.5.4-2-.3a8.7 8.7 0 01-.2-.3 33.7 33.7 0 00-1.8-3.7c-.7-1.2-2.1-2.9-2.9-4a27.7 27.7 0 00-4.1-3.8 19.9 19.9 0 00-5.1-2.8 1.4 1.4 0 01-.5-2.4c2.2-2 5.8-5.5 8.1-6.7.4-.2.6-.6.6-1l-.2-9.4c0-.8.7-1.3 1.4-1 2 .9 6 2.8 8.2 5.4.2.3.6.4 1 .3 1.7-.5 6.4-1.9 11-2.1a1 1 0 011 1.1c-.2 2.3-.8 7.1-1.8 10.3-.1.3 0 .7.2 1a69 69 0 015.3 8c.4.6 0 1.5-.8 1.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFC",
    d: "M14.8 24.2l-1.3.3a.7.7 0 01-.7-.8l.6-2.4-5.4-2a.9.9 0 01-.3-1.5c3-2.6 12-10 21.8-11.1a.4.4 0 01.5.5 41 41 0 01-10.8 21.5.8.8 0 01-1.3-.3l-2-4.6-1.1.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#siteJabber_svg__f)",
    d: "M22.3 17.2a3 3 0 003-3 3 3 0 00-3-3 3 3 0 00-3 3 3 3 0 003 3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.3 15.8a4.5 4.5 0 00-3.3-1.3c-1.6 0-2.6.5-2.6 1.6 0 1 1 1.5 2.7 1.6 2.3.3 5.4.8 5.3 4.1 0 2.4-2 4-5.3 4-2 0-4.1-.4-5.8-2.3l1.4-1.9a6 6 0 004.4 1.9c1.3 0 2.7-.5 2.7-1.7 0-1.1-1-1.6-2.9-1.8-2.4-.2-5.1-1-5.1-3.8 0-2.9 2.9-4 5.2-4 2 0 3.4.5 4.9 1.8l-1.6 1.8zm7.7-7c0 2.2-3.3 2.2-3.3 0s3.3-2.2 3.3 0zm-3 3.7v13h2.7v-13H57zM67.3 9v3.7H71V15h-3.7v6.2c0 1.3.6 2.1 1.8 2.1.5 0 1.1-.2 1.6-.4l.8 2.3c-.9.4-1.6.5-2.5.5-2.8.1-4.3-1.5-4.3-4.5V15h-2.4v-2.4h2.4V9.1l2.6-.2zm8.3 11c.3 2 1.9 3.3 4.1 3.3 1.3 0 3-.5 3.7-1.4l1.7 1.7a7.5 7.5 0 01-5.4 2.2c-4.2 0-6.8-2.7-6.8-6.8 0-4 2.7-6.7 6.6-6.7 4 0 6.8 2.5 6.3 7.7H75.6zm7.7-2.3c-.2-2-1.6-3-3.7-3-2 0-3.5 1-4 3h7.7zm7.9-5.2V27c0 3.3-1.2 5-4 5-1 0-1.9-.3-2.7-.9l1-2.1c.5.3 1 .4 1.6.4 1.3 0 1.5-.9 1.5-2.4V12.5h2.6zm-3-3.8c0 2.3 3.3 2.3 3.3 0 0-2.2-3.3-2.2-3.3 0zm16.7 3.9h2.5v12.9H105l-.1-2.1c-.8 1.6-2.8 2.4-4.4 2.4-3.6 0-6.4-2.4-6.4-6.8 0-4.3 2.9-6.7 6.5-6.7 1.8 0 3.5.8 4.3 2.3v-2zM96.6 19c0 2.7 1.9 4.3 4.1 4.3 5.5 0 5.5-8.5 0-8.5-2.2 0-4 1.6-4 4.2zm17-11.8v7.4c.9-1.6 3-2.3 4.5-2.3 3.7 0 6.4 2.3 6.4 6.7 0 4.2-2.8 6.7-6.5 6.7a4.9 4.9 0 01-4.3-2.3l-.2 2H111V7.1h2.7zm.2 11.8c0 2.5 1.8 4.2 4 4.2s4-1.6 4-4.2-1.8-4.2-4-4.2a4 4 0 00-4 4.2zm16.1-11.8v7.4c.9-1.6 3-2.3 4.5-2.3 3.6 0 6.4 2.3 6.4 6.7 0 4.2-2.8 6.7-6.5 6.7a4.9 4.9 0 01-4.4-2.3l-.1 2h-2.5V7.1h2.6zm.2 11.8c0 2.5 1.8 4.2 4 4.2s4-1.6 4-4.2-1.8-4.2-4-4.2a4 4 0 00-4 4.2zm15.4 1c.3 2 1.9 3.3 4.1 3.3 1.3 0 3-.5 3.7-1.4l1.7 1.7a7.4 7.4 0 01-5.4 2.2c-4.2 0-6.8-2.7-6.8-6.8 0-4 2.7-6.7 6.6-6.7 4 0 6.8 2.5 6.3 7.7h-10.2zm7.7-2.3c-.1-2-1.6-3-3.7-3-2 0-3.5 1-4 3h7.7zm7.7-5.1l.2 1.7c.9-1.7 2.3-2 3.7-2a5 5 0 013.1 1l-1.2 2.4a3.2 3.2 0 00-2.2-.8c-1.8 0-3.4 1.1-3.4 3.5v7h-2.7V12.5h2.5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "siteJabber_svg__a",
    x1: 7.8,
    x2: 13.9,
    y1: 38.3,
    y2: 32.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#25E2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19A6D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "siteJabber_svg__b",
    x1: -0.5,
    x2: 7,
    y1: 30.8,
    y2: 23.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E55EC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8225D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "siteJabber_svg__c",
    x1: 8.8,
    x2: 3.4,
    y1: 29.5,
    y2: 33.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A443FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A959F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "siteJabber_svg__d",
    x1: 6.8,
    x2: 62.1,
    y1: 31.7,
    y2: -32.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "siteJabber_svg__e",
    x1: 34.9,
    x2: 8.5,
    y1: 3.1,
    y2: 24.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#52BFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7238DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "siteJabber_svg__f",
    x1: 32,
    x2: 10.6,
    y1: 2.4,
    y2: 26.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52BFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7238DF"
  })))));
}
export default SvgSiteJabber;